var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"event-link",attrs:{"to":{ name: _vm.where, params: { trackid: _vm.category.track_id } }}},[_c('div',{staticClass:"event-card -shadow p-2 m-2"},[_c('h4',{staticClass:"title mt-1"},[_vm._v(" "+_vm._s(_vm.category.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }